import React from 'react';
import styled from 'styled-components'

const Span = styled.span`
width: 100vw;
height: 100vh;
background-color: pink;
`
const Hi =()=><Span>Ooops! <i className="far fa-smile"/></Span>
export { Hi }


// WEBPACK FOOTER //
// ./src/components/UI/Hi.js